export const environmentScoped = ['users', 'segments', 'contexts', 'live'];
export const projectScoped = ['features', 'flags', 'goals', 'metrics', 'integrations'];
export const unscoped = [
  'settings',
  'projects',
  'check-your-email',
  'confirm-your-email',
  'verify-email',
  'approvals',
  'internal',
  'profile',
];
